// Topics of the article / glossary inline contact form (InlineContactCta), in display order. The mail
// always carries the English label, so the sales inbox reads the same whatever the page locale; the
// on-page labels are `inlineContact.topics.<key>` in common.json.
export const INLINE_CONTACT_TOPICS = {
  ai_agents: 'AI agents & automation',
  ai_product: 'AI features in my product',
  ai_strategy: 'AI strategy & readiness',
  other: 'Other software project',
} as const;

export type InlineContactTopic = keyof typeof INLINE_CONTACT_TOPICS;

// Pre-selected, so the form is one field + one click.
export const DEFAULT_INLINE_CONTACT_TOPIC: InlineContactTopic = 'ai_agents';
